import {v4 as uuid} from 'uuid';
import {ALVA_TOKEN_KEY} from "./constants";


export const getToken = () => {
    return localStorage.getItem(ALVA_TOKEN_KEY);
};

export const clearToken = () => {
    localStorage.removeItem(ALVA_TOKEN_KEY);
};

export const buildRequestHeaders = () => {
    let headers: any = {};

    headers['Content-Type'] = 'application/json';
    let token = getToken();

    headers['Alva-Correlation-Id'] = uuid();
    headers['Authorization'] = `Bearer ${token}`;

    return headers;
};

export function setToken(token: string) {
    localStorage.setItem(ALVA_TOKEN_KEY, token);
}

